var map = {
	"./BMI计算.png": 8271,
	"./videos/Dallymotion.png": 8072,
	"./videos/Facebook.png": 2906,
	"./videos/Flickr.png": 3964,
	"./videos/Liveleak.png": 7327,
	"./videos/PBSvideo.png": 1979,
	"./videos/Tiktok.png": 9280,
	"./videos/Twitter.png": 9718,
	"./videos/VK.png": 608,
	"./videos/Veoh.png": 6847,
	"./videos/Vimeo.png": 9251,
	"./videos/YouTube.png": 924,
	"./videos/adult_sites.png": 7848,
	"./videos/howToDownload1.png": 8654,
	"./videos/howToDownload2.png": 4890,
	"./videos/local_sites.png": 5304,
	"./videos/top_sites.png": 7956,
	"./videos/use1.png": 6784,
	"./videos/use2.png": 4767,
	"./videos/use3.png": 2132,
	"./主页.png": 5095,
	"./假期查看.png": 6636,
	"./出生天数.png": 6170,
	"./实际年龄.png": 8118,
	"./抽签.png": 5231,
	"./推特scan.png": 1679,
	"./日期倒數.png": 6690,
	"./日期计算.png": 4333,
	"./视频下载.png": 9345,
	"./调色盘.png": 223,
	"./随机数.png": 4739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;